<template>
  <el-dropdown @command="handleCommand" trigger="click">
    <span class="el-dropdown-link">
      {{lang}}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh">{{$t('login.zh')}}</el-dropdown-item>
      <el-dropdown-item command="en">{{$t('login.en')}}</el-dropdown-item>
      <el-dropdown-item command="zhTW">{{$t('login.zhTW')}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  data() {
    return {
      lang: '中文',
    };
  },
  created() {
    this.lang = this.$t(`login.${this.$i18n.locale}`);
    Cookies.set('lang', this.$i18n.locale);
  },
  methods: {
    handleCommand(lang) {
      this.lang = this.$t(`login.${lang}`);
      localStorage.setItem('lang', lang);
      Cookies.set('lang', lang);
      if (this.lang !== lang) {
        window.location.reload();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  color: #ffffff;
  text-align: right;
  cursor: pointer;
}
</style>
<style lang="scss">
@import '../../../../assets/theme/_themes.scss';
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #16252E;
  top: 0;
}
.el-dropdown-menu {
  background-color: #16252E;
  border-color:#464e55;
}
</style>
